<template>
  <transition>
    <div v-if="isShow" name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper" @click="cancel">
            <ValidationObserver ref="observer">
              <div id="content" @click.stop="">
                <div class="modal-text mb-4 text-center">Add Group</div>
                <div>
                  <div class="mb-4">
                    <div>Fiscal Year Semester</div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <FiscalYearSemesterInput v-model="selectedYearSemester" />
                      <div class="error-text">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="mb-4">
                    <div>Assignment Name</div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input type="text" v-model="assignmentName" />
                      <div class="error-text">{{ errors[0] }}</div>
                      <div v-if="hasError" class="error-text">duplicate name.</div>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="common__button-container">
                  <div :class="['ok-button', {'disabled': isLoading}]" @click="addGroup">
                    <span v-show="!isLoading">Add</span>
                    <font-awesome-icon v-show="isLoading" icon="spinner" spin />
                  </div>
                  <div :class="['cancel-button', {'disabled': isLoading}]" @click="cancel">
                    Cancel
                  </div>
                </div>
                <span class="chancel-button" @click="cancel" v-show="!isLoading">
                  <font-awesome-icon  icon="times"/>
                </span>
              </div>
            </ValidationObserver>
          </div>
        </div>
    </div>
  </transition>
</template>

<script lang="ts">
import _ from 'lodash';
import FiscalYearSemesterInput from '@/components/parts/inputItem/FiscalYearSemesterInput.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'
import { FiscalYearSemester } from '@/store/common.types'
import { AssignmentStatus } from '@/store/groups/formation/types';
import { Semester } from '@/store/master/types';

@Component({
  components: {
    FiscalYearSemesterInput,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AcademicCalendar extends Vue {
  @Prop() isLoadingMode?: boolean

  private isLoading: boolean = false

  private isShow: boolean = false

  private hasError: boolean = false

  private selectedYearSemester: FiscalYearSemester|null = null

  private assignmentName: string = ''

  private get assignmentNames(): string[] {
    return _.chain(this.$store.state.groups.formation.assignments)
      .filter({
        year: this.selectedYearSemester?.fiscalYear,
        semester: this.selectedYearSemester?.semester,
      })
      .map('name')
      .value()
  }

  // モーダルを開く
  open() {
    this.isShow = true;
    this.isLoading = false;
    this.selectedYearSemester = null;
    this.assignmentName = '';
    this.hasError = false;
  }

  // モーダルを閉じる
  close() {
    this.isShow = false;
  }

  // addボタン押下時
  addGroup() {
    (this.$refs.observer as any).validate()
      .then((result: any) => {
        if (!result) return
        if (_.includes(this.assignmentNames, this.assignmentName)) {
          this.hasError = true;
          return;
        }

        const assignment: AssignmentStatus = {
          year: this.selectedYearSemester?.fiscalYear as number,
          semester: this.selectedYearSemester?.semester as Semester,
          name: this.assignmentName,
          step: 0,
        }
        this.$emit('ok', assignment);
        this.close();
      });
  }

  // cancelボタン押下時
  cancel() {
    if (!this.isLoading) {
      this.close();
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

#content{
  z-index:2;
  width:25%;
  min-width: 300px;
  margin: 0px auto;
  padding: 50px 30px 30px 30px;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  transition: all .3s ease;
  flex-direction: column;
  justify-content: space-between;
}

.ok-button, .cancel-button {
  color: #fff;
  padding:10px 20px;
  border-radius: 30px;
  display: block;
  width: 100px;
  margin:auto;
  cursor: pointer;
  transition:.2s;
  font-size: 13px;

}

.ok-button{
  text-align: center;
  border: 3px solid #1cc8a0;
  background: #1cc8a0;
}

.ok-button:hover {
  background: #fff;
  color:#1cc8a0;
}

.cancel-button{
  text-align: center;
  border: 3px solid #eee;
  background: #eee;
  color:#000;
}

.cancel-button:hover{
  background: #D8D8D8;
}

.cancel-button.disabled {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.cancel-button.disabled:hover {
  border: 3px solid #FFFFFF;
  background: #FFFFFF;
  color:#999;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.modal-text {
  font-size: 20px;
}

.v-enter-active {
  transition: opacity .3s
}

.v-enter {
  opacity: 0
}

.button-container {
  display: flex;
  margin-top:30px;
}

.modal-enter #content,
.modal-leave-active #content {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.text-box {
  margin-bottom:60px;
}

input[type="text"], select{
  padding: 5px;
  width: 100%;
  line-height: 0;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
}

</style>
